import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classnames from "classnames";
import { isImageURL, isURL } from '../../../slices/helper.js';
import { Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import Pagination from "../../../Components/Common/Pagination";
import { getPreviewInfo } from '../../../slices/feeds/thunk';

function Preview({ reload = false }) {
  const dispatch = useDispatch();
  const selectFeedInfo = createSelector((state) => state.Feed, (state) => ({
    preview: state.preview,
    isChangesMade: state.isChangesMade,
    feedInfo: state.feedInfo,
    previewErr: state.previewErr,
    previewErrMsg: state.previewErrMsg
  }));
  const { preview, isChangesMade, feedInfo, previewErr, previewErrMsg } = useSelector(selectFeedInfo);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    try {
      sortData(preview);
    } catch (e) {
      setData(preview);
    }
  }, [preview]);

  const sortByNumber = (a, b) => {
    return a.key - b.key;
  };

  const sortData = (preview) => {
    const sortedData = [...preview].sort(sortByNumber);
    setData(sortedData);
  };

  function refreshPreview() {
    dispatch(getPreviewInfo(feedInfo));
  }

  return (
    <React.Fragment>
      <React.Fragment>
        {preview.length > 0 ?
          <Card className={classnames({ "changes-made opacity-50": reload && isChangesMade })}>
            <CardHeader className='d-flex align-items-center justify-content-between'>
              {reload && isChangesMade ?
                <span className='fs-12'>
                  Refresh to see the latest changes!
                </span>
                : <span className='fs-14'>#{currentPage}</span>}
              {reload ?
                <button className='btn btn-soft-info btn-icon' id='reload-preview' type='button' onClick={refreshPreview}>
                  <i className='mdi mdi-refresh fs-5'></i>
                </button>
                : null
              }
            </CardHeader>
            <CardBody className='pt-2 px-0'>
              {(data || []).map((item, idx) => {
                return (
                  <div className='w-100 py-2 px-3' key={idx}>
                    <p className='m-0'>{item.name}</p>
                    {isURL(item.values[currentPage - 1]) ? 
                      isImageURL(item.values[currentPage - 1]) ?
                        <img height="40" src={item.values[currentPage - 1]} draggable="false" />
                      :
                      <a href={item.values[currentPage - 1]}>{item.values[currentPage - 1]}</a>
                        : typeof item.values[currentPage - 1] !== 'object' ?
                          <p className='text-muted text-truncate m-0'>{item.values[currentPage - 1]}</p>
                        :
                          null
                    }
                  </div>
                )
              })}
            </CardBody>
            <CardFooter className='d-flex px-0 align-items-center justify-content-center'>
              <Pagination data={(preview[0] !== undefined ? preview[0].values : [])} currentPage={currentPage} setCurrentPage={setCurrentPage} perPageData={1} />
            </CardFooter>
          </Card>
          :
          <p>Select fields to include in your feed</p>
        }
      </React.Fragment>
    </React.Fragment>
  )
}

export default Preview
